import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Sidebarlayout from "../wrapper/Sidebarlayout";
import LoginPage from "../@components/LoginPage";
import DescopeLoginPage from "../@components/LoginPage/DescopeLogin";
import Preference from "../../BIKES24/Bikes24DataCollection/Preference";
import Dashboard from "../@components/Dashboard";
import Scrubber from "../../BIKES24/Bikes24DataCollection/Scrubber";
import WhatsappTemplate from "../../BIKES24/Bikes24DataCollection/WhatsappTemplate";
import CrateEditFlowForWp from "../../BIKES24/Bikes24DataCollection/WhatsappTemplate/flow";
import CommunicationTemplate from "../../BIKES24/Bikes24DataCollection/CommunicationTemplate";
import CrateEditFlowForCommunication from "../../BIKES24/Bikes24DataCollection/CommunicationTemplate/flow";
const AllRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route
          path="/login"
          element={
            process.env.REACT_APP_IS_DESCOPE === "true" ? (
              <DescopeLoginPage />
            ) : (
              <LoginPage />
            )
          }
        />        <Route element={<Sidebarlayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard/user-notification" element={<Preference />} />
          <Route path="/dashboard/user-notification/number-scrubber" element={<Scrubber />} />
          <Route path="/dashboard/user-notification/whatsapp-template" element={<WhatsappTemplate />} />
          <Route path="/dashboard/user-notification/whatsapp-template/new" element={<CrateEditFlowForWp />} />
          <Route path="/dashboard/user-notification/whatsapp-template/:id" element={<CrateEditFlowForWp />} />
          <Route path="/dashboard/user-notification/communication-template" element={<CommunicationTemplate />} />
          <Route path="/dashboard/user-notification/communication-template/new" element={<CrateEditFlowForCommunication />} />
          <Route path="/dashboard/user-notification/communication-template/:id" element={<CrateEditFlowForCommunication />} />
    
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AllRoutes;
